import { useEffect } from "react";
import { X } from "lucide-react";

const CommonSnackbar = ({ message, type = "success", onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onClose) onClose();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="fixed top-[60px] md:top-[72px] left-1/2 -translate-x-1/2 z-[9999] max-w-[94vw] px-2 md:px-0">
      <div
        className={`
          relative flex items-center gap-2 px-4 py-2 rounded-md shadow-md text-white text-[12px] md:text-snackBarFontSize font-normal
          transition-all duration-300
          ${type === "success" ? "bg-successColor" : "bg-errorColor"}
        `}
      >
        <span className="break-words">{message}</span>

        <button
          onClick={onClose}
          className="ml-2 flex-shrink-0 text-white hover:opacity-80 focus:outline-none"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default CommonSnackbar;
